/**
 * 商品ページ　お取り寄せボタンつきセクション用 JvaScript
 * お取り寄せボタンを押したら、hiddenフィールドに値をセットして、Ajaxカートに送信する
 * カートイン時のみ簡易在庫チェック機能を追加
 */
document.addEventListener('DOMContentLoaded', function () {
  const orderFromStoreBtn = document.querySelector('.ProductForm__AddToCart[data-action="order-from-store"]');
  const normalAddToCartBtn = document.querySelector('.ProductForm__AddToCart[data-action="add-to-cart"]');
  const ATOPLA_LABEL = "店舗お取り寄せ";

  // === 商品データを取得する関数 ===
  function getCurrentProductData() {
    const productJsonElement = document.querySelector('[data-product-json]');
    if (productJsonElement) {
      try {
        return JSON.parse(productJsonElement.innerHTML);
      } catch (error) {
        return null;
      }
    }
    return null;
  }


  // === 簡易在庫チェック関数 ===
  function checkInventoryBeforeAdd(variantId, quantityToAdd) {
    return fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const variantIdNumber = parseInt(variantId);
        const existingItems = cart.items.filter(item => item.variant_id === variantIdNumber);
        const currentQuantity = existingItems.reduce((sum, item) => sum + item.quantity, 0);

        const productData = getCurrentProductData();
        if (!productData) {
          return { canAdd: true };
        }

        // 商品のバリアント情報を取得
        const variant = productData.product.variants.find(v => v.id === variantIdNumber);
        if (!variant) {
          return { canAdd: true };
        }

        // === 修正: 在庫管理が無効または在庫数が不明の場合でも、デフォルトで在庫1として扱う ===
        // 在庫数の取得（複数の方法を試行）
        let maxInventory = 1; // デフォルト値

        // 方法1: variant.inventory_quantity を直接確認
        if (variant.inventory_quantity !== null && variant.inventory_quantity !== undefined) {
          maxInventory = parseInt(variant.inventory_quantity);
        }
        // 方法2: inventory_management で判定
        else if (variant.inventory_management === 'shopify') {
          maxInventory = 1; // 在庫管理有効の場合は1として扱う
        }
        // 方法3: available プロパティで判定
        else if (variant.available === false) {
          maxInventory = 0;
        }
        else {
          maxInventory = 1; // デフォルト
        }



        // 在庫数が0以下の場合は追加を拒否
        if (maxInventory <= 0) {
          return {
            canAdd: false,
            message: 'この商品は在庫切れです。'
          };
        }

        // 在庫チェック
        if (currentQuantity + quantityToAdd > maxInventory) {
          return {
            canAdd: false,
            message: `同じ商品をカートに追加しようとしています。カートの内容をご確認ください。`
          };
        }

        return { canAdd: true };
      })
      .catch(error => {
        return { canAdd: true }; // エラーの場合は追加を許可
      });
  }

  // === 通常の購入ボタンの処理 ===
  if (normalAddToCartBtn) {
    // 既存のイベントリスナーを削除してから追加
    const newButton = normalAddToCartBtn.cloneNode(true);
    normalAddToCartBtn.parentNode.replaceChild(newButton, normalAddToCartBtn);

    // 新しいボタンにイベントリスナーを追加
    newButton.addEventListener('click', async function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      const productForm = this.closest('form');
      if (!productForm) return;

      const variantIdElement = productForm.querySelector('input[name="id"]');
      if (!variantIdElement) return;

      const variantId = variantIdElement.value;
      const quantityInput = productForm.querySelector('[name="quantity"]');
      const quantity = parseInt(quantityInput ? quantityInput.value : 1);

      // 在庫チェック
      try {
        console.log('variantID:', variantId);
        console.log('quantity:', quantity);
        const result = await checkInventoryBeforeAdd(variantId, quantity);

        if (!result.canAdd) {
          alert(result.message);
          // showInventoryMessage(result.message, true);
          return;
        }
        // 在庫チェックOKの場合、protegerの処理を実行
        if (window.Proteger && window.ProtegerShopify) {
          const component = window.Proteger.buttons.instance('proteger-offer');
          if (component) {
            const plan = component.getPlanSelection();
            const variantIdNumber = parseInt(variantId);

            window.ProtegerShopify.addPlanToCart({
              productId: variantIdNumber,
              plan: plan,
              quantity: quantity,
              productHandler: function () {
                // 元のボタンのクリックイベントを実行せず、直接カートに追加
                const formData = new FormData(productForm);

                fetch('/cart/add.js', {
                  method: 'POST',
                  body: formData,
                })
                  .then(response => response.json())
                  .then(data => {
                    window.location.href = '/cart';
                  })
                  .catch(error => {
                    alert('カート追加に失敗しました');
                  });
              },
              modal: true,
            });
          }
        }
      } catch (error) {
        alert('在庫チェック中にエラーが発生しました。');
      }
    }, true);
  }

  // === お取り寄せボタンの処理 ===
  if (orderFromStoreBtn) {
    orderFromStoreBtn.addEventListener('click', function (event) {
      event.preventDefault();
      const productForm = orderFromStoreBtn.closest('form');
      if (!productForm) return;

      const variantIdElement = productForm.querySelector('input[name="id"]');
      if (!variantIdElement) return;

      const variantId = variantIdElement.value;
      const quantityInput = productForm.querySelector('[name="quantity"]');
      const quantity = parseInt(quantityInput ? quantityInput.value : 1);

      // 在庫チェック
      checkInventoryBeforeAdd(variantId, quantity).then(result => {

        if (!result.canAdd) {
          alert(result.message);
          // showInventoryMessage(result.message, true);
          return;
        }

        // 在庫チェックOKの場合、カートに追加
        // hiddenフィールドの値をセット
        let orderTypeField = productForm.querySelector('input[name="properties[_atopla]"]');
        if (!orderTypeField) {
          orderTypeField = document.createElement('input');
          orderTypeField.type = 'hidden';
          orderTypeField.name = 'properties[_atopla]';
          orderTypeField.id = 'order-type-field';
          productForm.appendChild(orderTypeField);
        }
        orderTypeField.value = ATOPLA_LABEL;

        // Ajaxカート用の送信
        const formData = new FormData(productForm);
        formData.set('properties[_atopla]', orderTypeField.value);

        fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
        })
          .then(response => response.json())
          .then(data => {
            window.location.href = '/cart';
          })
          .catch(error => {
            alert('カート追加に失敗しました');
          });
      });
    });
  }
});


//  商品詳細ページ　お取り寄せ購入について説明用ポップアップ
// ポップアップ表示
function showAtoplaModal() {
  const popup = document.getElementById('rw-atopla-modal');
  if (popup) {
    popup.classList.remove('hidden');
  }
}

// ポップアップ閉じる
document.addEventListener('DOMContentLoaded', function() {
  const popup = document.getElementById('rw-atopla-modal');
  const overlay = document.querySelector('.rw-atopla-modal-overlay');
  const closeButton = document.querySelector('.rw-atopla-modal-close');

  // 背景クリックで閉じる
  if (overlay) {
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) { // 背景クリック時のみ反映
        popup.classList.add('hidden');
      }
    });
  }

  // 閉じるボタンクリックで閉じる
  if (closeButton) {
    closeButton.addEventListener('click', function(e) {
      popup.classList.add('hidden');
    });
  }
});


// お取り寄せ説明用モーダルをbodyに移動（ヘッダーの上に表示するため）
document.addEventListener('DOMContentLoaded', function() {
  const modalContainer = document.getElementById('rw-atopla-modal');
  if (modalContainer) {
      document.body.appendChild(modalContainer);
  }
});